import React, { useState } from "react";
import "./ChangePasswordDialog.css";
import { Dialog, DialogTitle, DialogContent } from "@mui/material";
import { IoMdClose } from "react-icons/io";
import { PiEyeLight, PiEyeClosedLight } from "react-icons/pi";
import api from "../services/baseUrl";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const ChangePasswordDialog = ({ openDialog, setOpenDialog, onSuccess }) => {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isNewPasswordVisible, setIsNewPasswordVisible] = useState(false);
  const [isConfirmPasswordVisible, setIsConfirmPasswordVisible] =
    useState(false);

  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  // const cookie = Cookies.get("user") || sessionStorage.getItem("user");
  const cookie = sessionStorage.getItem("user");
  const userObject = JSON.parse(cookie);
  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };

  const toggleNewPasswordVisibility = () => {
    setIsNewPasswordVisible(!isNewPasswordVisible);
  };

  const toggleConfirmPasswordVisibility = () => {
    setIsConfirmPasswordVisible(!isConfirmPasswordVisible);
  };

  const isValidPassword = (password) => {
    // Check for non-blank printable characters
    if (!password || password.length < 9) {
      return false;
    }

    // Flags for the criteria
    let hasUpperCase = false;
    let hasLowerCase = false;
    let hasNumber = false;
    let hasSpecialChar = false;

    // Loop through each character to check for the criteria
    for (let char of password) {
      if (/[A-Z]/.test(char)) hasUpperCase = true;
      if (/[a-z]/.test(char)) hasLowerCase = true;
      if (/\d/.test(char)) hasNumber = true;
      if (/[!@#$%^&*(),.?":{}|<>]/.test(char)) hasSpecialChar = true;
    }
    
    // Count how many criteria are satisfied
    const criteriaMet = [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length;

    console.log(criteriaMet);
    // Check if at least 3 out of 4 criteria are met
    if (criteriaMet >= 3) {
      return true;
    } else {
      return false;
    }
  };

  const changePassword = async (e) => {
    e.preventDefault();
    setError("");

    if (!isValidPassword(newPassword)) {
      setError("Test Error");
      return;
    }

    if (newPassword !== confirmPassword) {
      alert("New password and confirmation do not match.");
      return;
    }

    try {
      const username = userObject.user.userName;

      const response = await api.post("/user/updatepassword", {
        username,
        currentPassword,
        newPassword,
      });

      if (response.status === 200) {
        toast.success("Password successfully changed");
        onSuccess?.();
        // Delay closing the dialog to allow toast to appear
        setTimeout(() => {
          setOpenDialog(false);
          setConfirmPassword("");
          setCurrentPassword("");
          setNewPassword("");
        }, 1500); // 1.5 seconds delay (adjust if needed)
      }
    } catch (error) {
      if (error.response && error.response.data) {
        setError(error.response.data.message || "Failed to update password.");
      } else {
        setError("Something went wrong.");
      }
    }
  };

  return (
    <Dialog
      open={openDialog}
      PaperProps={{
        style: {
          width: "500px",
          height: "450px",
          borderRadius: "8px",
        },
      }}
    >
      <DialogTitle
        style={{
          fontSize: 25,
          fontWeight: 600,
        }}
      >
        Change password
      </DialogTitle>
      <IoMdClose
        size={30}
        className="pwd-dialog-icon"
        onClick={() => setOpenDialog(false)}
      />
      <DialogContent>
        <form className="pwd-dialog-form" onSubmit={changePassword}>
          <div>
            <div className="pwd-dialog-input-field">
              <label htmlFor="current-password">Current Password</label>
              <div className="pwd-dialog-password">
                <input
                  type={isPasswordVisible ? "text" : "password"}
                  name="current-password"
                  id="current-password"
                  value={currentPassword}
                  onChange={(e) => setCurrentPassword(e.target.value)}
                  required
                />
                <span
                  className="pwd-dialog-toggle-icon"
                  onClick={togglePasswordVisibility}
                >
                  {isPasswordVisible ? (
                    <PiEyeLight size={16} />
                  ) : (
                    <PiEyeClosedLight size={16} />
                  )}
                </span>
              </div>
            </div>
            <div className="pwd-dialog-input-field">
              <label htmlFor="new-password">New Password</label>
              <div className="pwd-dialog-password">
                <input
                  type={isNewPasswordVisible ? "text" : "password"}
                  name="new-password"
                  id="new-password"
                  value={newPassword}
                  onChange={(e) => setNewPassword(e.target.value)}
                  required
                />
                <span
                  className="pwd-dialog-toggle-icon"
                  onClick={toggleNewPasswordVisibility}
                >
                  {isNewPasswordVisible ? (
                    <PiEyeLight size={16} />
                  ) : (
                    <PiEyeClosedLight size={16} />
                  )}
                </span>
              </div>
            </div>
            <div className="pwd-dialog-input-field">
              <label htmlFor="confirm-password">Confirm New Password</label>
              <div className="pwd-dialog-password">
                <input
                  type={isConfirmPasswordVisible ? "text" : "password"}
                  name="confirm-password"
                  id="confirm-password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                />
                <span
                  className="pwd-dialog-toggle-icon"
                  onClick={toggleConfirmPasswordVisibility}
                >
                  {isConfirmPasswordVisible ? (
                    <PiEyeLight size={16} />
                  ) : (
                    <PiEyeClosedLight size={16} />
                  )}
                </span>
              </div>
            </div>
            {error && (
              <p  className="form-error">
                <p>New Password/Confirm New Password should be minimum 9 non-blank printable characters</p>
                <p>
                  It should also comply to 3 out of 4 of the following criteria:<br/>
                  ■ Should contain English Upper Case<br/>
                  ■ Should contain English Lower Case<br/>
                  ■ Numeric Characters (0 to 9)<br/>
                  ■ Special (printable) characters<br/>
                </p>
              </p>
            )}
            <button className="pwd-dialog-button" type="submit">
              Update
            </button>
          </div>
        </form>
        <ToastContainer />
      </DialogContent>
    </Dialog>
  );
};

export default ChangePasswordDialog;
